import { createPlugin } from '@backstage/core-plugin-api';

export const rtlDataPlugin = createPlugin({
    id: 'rtl-data',
});
